(function componentForm($, Adzuki) {
	'use strict';

	var form = {
		name: 'FlightBookPnr',
	};

	var form_id = 'flightbookpnr-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var gmt_username_radio  = $('.gmt-user-switch');

		// pre-select pax type on page load (if available)
		$('.pax-type-field').each(function onEachPaxTypeField(i, el)
		{
			var index = $(this).data('pax-index');
			var value = $(this).val();

			if (value && value === 'new') {
				enablePaxFields(index);
				addNewClientNote(index);
				return true;
			}

			if (value && value === 'existing') {
				enablePaxFields(index);
				togglePaxLookup(index);
				showResetPaxBtn(index);
				return true;
			}

			if (value !== '') {
				$('.pax-' + index).find('.client-id').val(value);

				enablePaxFields(index);
			}
		});

		// pre-select cruise booking # on page load (if available)
		if ($('#' + form_id + 'reservation_id').val() !== '') {
			$('#' + form_id + 'vesselbookingid').prop('disabled', true);

			$('.reset-booking-typeahead').removeClass('hidden');
		}

		// when changing the passenger entry type (use existing/create new)
		$('.pax-type-field').change(function onPaxTypeChange(event)
		{
			var index = $(this).data('pax-index');
			var value = $(this).val();

			resetPaxFields(index);
			removeNewClientNote(index);

			if (value && value === 'new') {
				enablePaxFields(index);
				addNewClientNote(index);
				return;
			}

			if (value && value === 'existing') {
				togglePaxLookup(index);
				disablePaxFields(index);
				return;
			}

			if (value) {
				$('.pax-' + index).find('.client-id').val(value);

				enablePaxFields(index);

				Adzuki.Ajax.get('/Clients/getClientDetails/' + value)
				.then(function onSuccess(client)
				{
					populatePaxFields(index, client);
				});
			}
		});

		// Passenger lookup typeaheads
		$('.pax-lookup').each(function onEachPaxLookup(pax_index, input)
		{
			Adzuki.Typeahead(
				input,
				'/Clients/search',
				function onSelect(client, $self, typeahead) {
					typeahead.setHiddenValue(client.id);

					showResetPaxBtn(pax_index);
					resetPaxFields(pax_index);
					populatePaxFields(pax_index, client);
				}
			);
		});

		// Cruise Booking # lookup typeahead
		if ($('#' + form_id + 'vesselbookingid').length) {
			Adzuki.Typeahead(
				$('#' + form_id + 'vesselbookingid'),
				'/CruiseSearch/searchYetToDepart',
				function onSelect(cruise_component, $self, typeahead) {
					typeahead.setHiddenValue(cruise_component.confirmation_number);
					$self.val(cruise_component.confirmation_number);
					$self.prop('disabled', true);

					$('#' + form_id + 'vesselname').val(cruise_component.ship_name);
					$('#' + form_id + 'reservation_id').val(cruise_component.reservation_id);
					$('.reset-booking-typeahead').removeClass('hidden');

					populateRecommendedPassengers(cruise_component.reservation_id);
				}
			);
		}

		// Tour Booking # lookup typeahead
		if ($('#' + form_id + 'tourbookingid').length) {
			Adzuki.Typeahead(
				$('#' + form_id + 'tourbookingid'),
				'/Packages/searchYetToDepart',
				function onSelect(package_component, $self, typeahead) {
					typeahead.setHiddenValue(package_component.confirmation_number);
					$self.val(package_component.confirmation_number);
					$self.prop('disabled', true);

					$('#' + form_id + 'tourname').val(package_component.package_name);
					$('#' + form_id + 'reservation_id').val(package_component.reservation_id);
					$('.reset-booking-typeahead').removeClass('hidden');

					populateRecommendedPassengers(package_component.reservation_id);
				}
			);
		}

		// click to select a pax type (Select from List)
		$('.select-pax-entrytype').click(function onClickPaxEntryType(event)
		{
			var index = $(this).data('pax-index');

			event.preventDefault();

			$('.pax-' + index).find('.pax-type-field').val('');
			$('.pax-' + index).find('.reset-pax-typeahead').trigger('click');

			togglePaxLookup(index);
		});

		// click to reset the passenger selected from the typeahead
		$('.reset-pax-typeahead').click(function onClickResetTypeahead(event)
		{
			var index = $(this).data('pax-index');

			event.preventDefault();

			$('.pax-' + index).find('.reset-pax-typeahead').addClass('hidden');
			$('.pax-' + index).find('.pax-lookup').val('');
			$('.pax-' + index).find('.client-id').val('');

			resetPaxFields(index);
			disablePaxFields(index);
		});

		// click to reset the cruise booking # selected from the typeahead
		$('.reset-booking-typeahead').click(function onClickResetTypeahead(event)
		{
			event.preventDefault();

			$('.reset-booking-typeahead').addClass('hidden');
			$('#' + form_id + 'reservation_id').val('');

			// reset for cruise
			if ($('#' + form_id + 'vesselbookingid').length) {
				$('#' + form_id + 'vesselbookingid').prop('disabled', false);
				$('#' + form_id + 'vesselbookingid').val('');
				$('#' + form_id + 'vesselname').val('');
				$('#' + form_id + 'cruise_booking_id_search').val('');
			}

			// reset for tour
			if ($('#' + form_id + 'tourbookingid').length) {
				$('#' + form_id + 'tourbookingid').prop('disabled', false);
				$('#' + form_id + 'tourbookingid').val('');
				$('#' + form_id + 'tourname').val('');
				$('#' + form_id + 'tour_booking_id_search').val('');
			}
		});

		// click on flight rules link
		$('.flight-rules-btn').on('click', function onFlightRulesBtnClick(event)
		{
			event.preventDefault();

			$('.modal-title').text('Rules');
			$('.modal-body').html($('.flight-rules').html());
			$('.modal').modal('show');
		});

		// Toggling gmt username field
		gmt_username_radio.on('change', function onGmtUsernameRadioChange(event)
		{
			var agent_has_gmt_username = $(this).val();

			if (agent_has_gmt_username === '1') {
				$('.gmt-username-field').removeClass('hidden');
				return;
			}

			$('.gmt-username-field').addClass('hidden');
		});

		// calculator
		$('.pax-commission-field').on('pricechanged', function onPriceChanged(event)
		{
			calculateCommissionTotals();
		});

		$('.pax-fee-field').on('pricechanged', function onPriceChanged(event)
		{
			calculatePaxFeeTotals();
		});

		if ($('.pax-commission-field').length) {
			calculateCommissionTotals();
		}

		if ($('.pax-fee-field').length) {
			calculatePaxFeeTotals();
		}
	};

	function populateRecommendedPassengers(reservation_id)
	{
		Adzuki.Ajax.get('/Reservations/getRecommendedTravelers/reservation/' + reservation_id)
		.then(function onSuccess(response)
		{
			$('.pax-type-field').each(function onEachPaxTypeField(i, el)
			{
				var pax_type_value     = $(el).val();
				var recommended_markup = '';
				var other_markup       = '';

				if (response.length > 0) {
					$(el).empty().append('<option selected="1"></option>');
					other_markup += '<optgroup label="Other">';
					other_markup += '<option value="existing">Find Existing Client</option>';
					other_markup += '<option value="new">Create New Client</option>';
					other_markup += '</optgroup>';

					recommended_markup += '<optgroup label="Recommended Passengers">';
					$.each(response, function onEachPax(i, pax) {
						recommended_markup += '<option value="' + pax.id + '">';
						recommended_markup += pax.name;
						recommended_markup += '</option>';
					});
					recommended_markup += '</optgroup>';

					$(el).append(recommended_markup);
					$(el).append(other_markup);
					$(el).val(pax_type_value);
				}
			});
		});
	}

	function populatePaxFields(index, pax_data)
	{
		var field_id_prefix = '#' + form_id + 'passengers-' + index + '-';

		enablePaxFields(index);
		resetPaxFields(index);

		$(field_id_prefix + 'firstname').val(pax_data.first_name);
		$(field_id_prefix + 'lastname').val(pax_data.last_name);

		if (pax_data.middle_name) {
			$(field_id_prefix + 'middlename').val(pax_data.middle_name);
		}

		if (pax_data.gender) {
			$(field_id_prefix + 'gender').val((pax_data.gender === '0') ? 'M' : 'F');
		}

		if (pax_data.birthday) {
			$(field_id_prefix + 'birthdate').data('DateTimePicker')
											.date(moment(pax_data.birthday));
		}

		if (pax_data.passport_number) {
			$(field_id_prefix + 'passportid').val(pax_data.passport_number);
		}

		if (pax_data.passport_expiration) {
			$(field_id_prefix + 'passportexpdate')
				.data('DateTimePicker')
				.date(moment(pax_data.passport_expiration));
		}

		// passport country
		Adzuki.Ajax.get('/Clients/getClientPassportCountryId/' + pax_data.passport_place_issued)
		.then(function onSuccess(response)
		{
			if (response.passport_country_id === '') {
				// passport country id couldn't be figured out, use the country id from the client profile
				$(field_id_prefix + 'passportcountry').val(pax_data.country_id);
			} else {
				$(field_id_prefix + 'passportcountry').val(response.passport_country_id);
			}
		});

		Adzuki.Ajax.get('/Clients/getClientPrimaryPhone/' + pax_data.id)
		.then(function onSuccess(response)
		{
			if (response.phone) {
				$(field_id_prefix + 'passengerphone').val(response.phone);
			}
		});
	}

	// show/hide field to lookup for a client
	function togglePaxLookup(index)
	{
		var pax_typeahead   = $('.pax-' + index).find('.pax-typeahead').first();
		var select_pax_type = $('.pax-' + index).find('.select-pax-type').first();

		if (pax_typeahead.hasClass('hidden')) {
			pax_typeahead.removeClass('hidden');
		} else {
			pax_typeahead.addClass('hidden');
		}

		if (select_pax_type.hasClass('hidden')) {
			select_pax_type.removeClass('hidden');
		} else {
			select_pax_type.addClass('hidden');
		}
	}

	function resetPaxFields(index)
	{
		var pax_container = $('.pax-' + index);

		// hide validation error highlights (if any)
		pax_container.find('.form-group').removeClass('has-error');

		pax_container.find('.pax-field').val('');

		// clear out the date of birth datepicker
		$('#' + form_id + 'passengers-' + index + '-birthdate')
			.data('DateTimePicker').clear();
	}

	function showResetPaxBtn(index)
	{
		$('.pax-' + index).find('.reset-pax-typeahead')
						  .removeClass('hidden');
	}

	function addNewClientNote(index)
	{
		var pax_container = $('.pax-' + index);
		var markup        = '';

		markup += '<div class="alert alert-info new-client-note" role="alert">';
		markup += '<strong>Note:</strong> A new client profile will also be created when submitting this booking.';
		markup += '</div>';

		pax_container.prepend(markup);
	}

	function removeNewClientNote(index)
	{
		var pax_container = $('.pax-' + index);

		pax_container.find('.new-client-note').first().remove();
	}

	function disablePaxFields(index)
	{
		$('.pax-' + index).find('.pax-field').prop('disabled', true);
	}

	function enablePaxFields(index)
	{
		$('.pax-' + index).find('.pax-field').prop('disabled', false);
	}

	function calculateCommissionTotals()
	{
		var per_adult_commission = 0;
		var per_child_commission = 0;
		var url                  = '';

		// get commission values
		$('.pax-commission-field').each(function onEachCommField(i, el) {
			var pax_type = $(this).data('pax-type');

			if ($(this).val() !== '') {
				if (pax_type === 'ADT') {
					per_adult_commission = $(this).val();
				} else if (pax_type === 'CHD') {
					per_child_commission = $(this).val();
				}
			}
		});

		url = '/FlightBooking/calculateCommissions/' + String(per_adult_commission) + '/' + String(per_child_commission);

		Adzuki.Ajax.get(url).then(function onSuccess(response)
		{
			$('.pax-commission-adt').html(accounting.formatMoney(response.per_adult_commission));

			if ($('.pax-commission-chd').length) {
				$('.pax-commission-chd').html(accounting.formatMoney(response.per_child_commission));
			}

			$('.total-commission').html(accounting.formatMoney(response.total_commission));
			$('.total-gmt-fee').html(accounting.formatMoney(response.gmt_fee));
			$('.grand-total').html(accounting.formatMoney(response.grand_total));
		});
	}

	function calculatePaxFeeTotals()
	{
		var per_adult_fee = 0;
		var per_child_fee = 0;
		var url           = '';

		// get service fee values
		$('.pax-fee-field').each(function onEachPaxFeeField(i, el) {
			var pax_type = $(this).data('pax-type');

			if ($(this).val() !== '') {
				if (pax_type === 'ADT') {
					per_adult_fee = $(this).val();
				} else if (pax_type === 'CHD') {
					per_child_fee = $(this).val();
				}
			}
		});

		url = '/FlightBooking/calculatePaxFees/' + String(per_adult_fee) + '/' + String(per_child_fee);

		Adzuki.Ajax.get(url).then(function onSuccess(response)
		{
			$('.pax-fee-adt').html(accounting.formatMoney(response.per_adult_fee));

			if ($('.pax-fee-chd').length) {
				$('.pax-fee-chd').html(accounting.formatMoney(response.per_child_fee));
			}

			$('.total-fee').html(accounting.formatMoney(response.total_fee));
			$('.grand-total').html(accounting.formatMoney(response.grand_total));
		});
	}
}(jQuery, window.Adzuki || {}));
